import { addWOTReactiveListener, removeWOTReactiveListener } from '@wotfe/client2web'
import {
    subscribeToChannel as subscribeToChannelW2C,
    unsubscribeFromChannel as unsubscribeFromChannelW2C,
} from 'helpers/web_to_client'

export function subscribeToChannel(channel, callback) {
    subscribeToChannelW2C(channel)
    addWOTReactiveListener(
        channel,
        callback
    )
}

export function unsubscribeFromChannel(channel, callback) {
    unsubscribeFromChannelW2C(channel)
    removeWOTReactiveListener(
        channel,
        callback
    )
}

export function parseHermodJSONData({ data: c2wEventData }) {
    const jsonString = c2wEventData && c2wEventData.data
    try {
        return JSON.parse(jsonString)
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('>> WGSH cannot parse hermod data', jsonString)
        return null
    }
}



// WEBPACK FOOTER //
// ./helpers/hermod.js